export default {
  url: 'https://mcmedic.cloudmedic.ru',
  socketurl: 'wss://mcmedic.cloudmedic.ru:643/client',
  lkurl: 'https://lk.mcmedic.ru',
}
